export enum TypDoplnkuKUrednimuNazvu {
	VYBRAT_EXISTUJICI = 'VYBRAT_EXISTUJICI',
	ZALOZIT_NOVY = 'ZALOZIT_NOVY'
}
